import { Box, Button, Typography } from '@mui/material'
import MobileStepper from '@mui/material/MobileStepper'
import PropTypes from 'prop-types'
import { useState } from 'react'
import SwipeableViews from 'react-swipeable-views'
import { autoPlay } from 'react-swipeable-views-utils'
import { ChevronLeftIcon, ChevronRightIcon } from '~/assets/icons'
import useIsTablet from '~/hooks/useIsTablet'

const AutoPlaySwipeableViews = autoPlay(SwipeableViews)

function ImageCarousel({ images }) {
  const [activeStep, setActiveStep] = useState(0)
  const maxSteps = images.length
  const isTablet = useIsTablet()

  const handleStepChange = (step) => setActiveStep(step)

  const renderButtonPre = () => {
    if (!isTablet) return null
    return (
      <Button
        onClick={() => {
          setActiveStep((s) => Math.min(s + 1, images?.length - 1))
        }}>
        <div style={styles.button}>
          <ChevronRightIcon size={16} color="white" />
        </div>
      </Button>
    )
  }

  const renderButtonNext = () => {
    if (!isTablet) return null
    return (
      <Button
        onClick={() => {
          setActiveStep((s) => Math.max(s - 1, 0))
        }}>
        <div
          style={{
            ...styles.button,
            transform: 'rotate(180deg)',
          }}>
          <ChevronRightIcon size={16} color="white" />
        </div>
      </Button>
    )
  }

  return (
    <Box
      sx={{
        width: isTablet ? 551 : '100%',
        alignItems: 'center',
        justifyContent: isTablet ? 'flex-start' : 'center',
        display: 'flex',

        flexDirection: 'column',
      }}
      position={'relative'}>
      <AutoPlaySwipeableViews
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        style={{ width: '100%', borderRadius: isTablet ? 31.83 : 0 }}>
        {images.map((step, index) => (
          <Box key={index} style={{ display: 'flex', width: '100%' }}>
            {Math.abs(activeStep - index) <= 2 ? (
              <img
                src={step.url}
                alt=""
                style={{
                  aspectRatio: isTablet ? 1 / 1 : 390 / 290,
                  objectFit: 'cover',
                  width: isTablet ? 551 : '100%',
                }}
              />
            ) : null}
          </Box>
        ))}
      </AutoPlaySwipeableViews>
      {maxSteps > 1 && (
        <>
          <Typography
            component="div"
            marginTop={isTablet ? '17px' : 0}
            position={isTablet ? 'relative' : 'absolute'}
            display={'flex'}
            bottom={isTablet ? 0 : '10px'}
            justifyContent={'center'}
            alignItems={'center'}
            zIndex={2}>
            <MobileStepper
              nextButton={renderButtonPre()}
              backButton={renderButtonNext()}
              style={styles.stepperTablet}
              steps={maxSteps}
              activeStep={activeStep}
              sx={{
                display: maxSteps <= 1 ? 'none' : 'flex',
                position: isTablet ? 'relative' : 'absolute',
                bottom: '0px',
                zIndex: 2,
                color: '#40ACDD',
                '.MuiMobileStepper-dots': { gap: isTablet ? '30px' : '5px' },
                '.MuiMobileStepper-dot': {
                  width: isTablet ? '15px' : '5px',
                  height: isTablet ? '15px' : '5px',
                },
              }}
            />
          </Typography>
        </>
      )}
    </Box>
  )
}

ImageCarousel.propTypes = {
  images: PropTypes.array,
}

export default ImageCarousel

const styles = {
  stepper: {
    backgroundColor: 'transparent',
    height: '5px',
    width: '5px',
    color: '#40ACDD',
  },
  stepperTablet: {
    backgroundColor: 'transparent',
    height: '5px',
    width: '100%',
    color: '#40ACDD',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    backgroundColor: '#404040',
    display: 'flex',
    borderRadius: '100%',
    width: '38px',
    height: '38px',
    justifyContent: 'center',
    alignItems: 'center',
  },
}
